import styled from "styled-components";
import { CSSProperties } from "react";
import C from "@assets/themes/colors";

export const ContainerInputStyle: CSSProperties = {
  display: "flex",
  justifyContent: "center",
  marginTop: "10px",
}

export const InputStyle: CSSProperties = {
  height: "18px",
  fontSize: "12px",
  width: "77px",
  padding: "0px 5px",
}

export const Root = styled.div`
  position: relative;
`;

export const WarningError = styled.div`
  position: absolute;
  top: 95px;
  width: 176px;
  height: 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0px 4px 0px 6px;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.5);
  font-weight: 500;
  color: ${C.WHITE};
`;